import React from 'react';

const Spinner = () => {
  return (
    <div className='cup'></div>
  );
};

export default Spinner;